module.exports = __webpack_public_path__ + "img/vscode.fe44a75d.png";